import { render, staticRenderFns } from "./incomeConfirmed.vue?vue&type=template&id=deaa4bfe&scoped=true"
import script from "./incomeConfirmed.vue?vue&type=script&lang=js"
export * from "./incomeConfirmed.vue?vue&type=script&lang=js"
import style0 from "./incomeConfirmed.vue?vue&type=style&index=0&id=deaa4bfe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "deaa4bfe",
  null
  
)

export default component.exports